/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Title_DeedInputs */

const en_doc_type_title_deed = /** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Deed`)
};

const id_doc_type_title_deed = /** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akta Hak Milik`)
};

/** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */
const es_doc_type_title_deed = en_doc_type_title_deed;

/** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */
const fr_doc_type_title_deed = en_doc_type_title_deed;

/** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */
const de_doc_type_title_deed = en_doc_type_title_deed;

/** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */
const ja_doc_type_title_deed = en_doc_type_title_deed;

/** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */
const zh_doc_type_title_deed = en_doc_type_title_deed;

/** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */
const ar_doc_type_title_deed = en_doc_type_title_deed;

/** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */
const it_doc_type_title_deed = en_doc_type_title_deed;

/** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */
const ru_doc_type_title_deed = en_doc_type_title_deed;

/** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */
const pt_doc_type_title_deed = en_doc_type_title_deed;

/** @type {(inputs: Doc_Type_Title_DeedInputs) => LocalizedString} */
const ko_doc_type_title_deed = en_doc_type_title_deed;

/**
* | output |
* | --- |
* | "Title Deed" |
*
* @param {Doc_Type_Title_DeedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_title_deed = /** @type {((inputs?: Doc_Type_Title_DeedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Title_DeedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_title_deed(inputs)
	if (locale === "es") return es_doc_type_title_deed(inputs)
	if (locale === "fr") return fr_doc_type_title_deed(inputs)
	if (locale === "de") return de_doc_type_title_deed(inputs)
	if (locale === "ja") return ja_doc_type_title_deed(inputs)
	if (locale === "zh") return zh_doc_type_title_deed(inputs)
	if (locale === "ar") return ar_doc_type_title_deed(inputs)
	if (locale === "id") return id_doc_type_title_deed(inputs)
	if (locale === "it") return it_doc_type_title_deed(inputs)
	if (locale === "ru") return ru_doc_type_title_deed(inputs)
	if (locale === "pt") return pt_doc_type_title_deed(inputs)
	return ko_doc_type_title_deed(inputs)
});